var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "74px",
    viewBox: "0 0 80 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Generic-Errror-Page",
    transform: "translate(-793.000000, -207.000000)",
    fill: "#909199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/UI-Essentials/warning-triangle",
    transform: "translate(793.178511, 207.817661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.3543007,73 C77.3444166,73 77.3345325,73 77.3213537,73 L1.64554163,73 C1.06402825,73 0.526993232,72.690327 0.230470828,72.1858597 C-0.0660515753,71.6813924 -0.0775830021,71.0553867 0.202465935,70.54093 L38.040372,0.797907461 C38.6169433,-0.265969154 40.349952,-0.265969154 40.9265234,0.797907461 L78.624405,70.2828691 C78.8599755,70.5708983 79,70.9388431 79,71.3400861 C79,72.2557858 78.263636,73 77.3543007,73 Z M39.4834477,5.05341392 L4.42296815,69.6785073 L74.5455746,69.6785073 L39.4834477,5.05341392 Z M39.4834477,56.3925364 C41.2988237,56.3925364 42.7748464,57.8859595 42.7748464,59.715694 C42.7748464,61.5470935 41.2988237,63.0355219 39.4834477,63.0355219 C37.669719,63.0355219 36.1936963,61.5470935 36.1936963,59.715694 C36.1936963,57.8859595 37.669719,56.3925364 39.4834477,56.3925364 Z M39.4834477,48.0929669 C38.5757597,48.0929669 37.8377483,47.3470878 37.8377483,46.4313881 L37.8377483,26.5040967 C37.8377483,25.586732 38.5757597,24.8441828 39.4834477,24.8441828 C40.3927831,24.8441828 41.129147,25.586732 41.129147,26.5040967 L41.129147,46.4313881 C41.129147,47.3470878 40.3927831,48.0929669 39.4834477,48.0929669 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.09f0e1ecb69711672d72600f27a1f9cb.svg";
export { ForwardRef as ReactComponent };